import { gql } from "@apollo/client";
import { PatientFragment } from "./user.qql";

export const GET_PROFESSIONIST_APPOINTMENTS = gql`
  query myProfessionistAppointments {
    myProfessionistAppointments {
      id
      start_at
      has_patient_confirmed
      patient {
        ...PatientFragment
      }
    }
  }
  ${PatientFragment}
`;

export const GET_PATIENT_APPOINTMENTS = gql`
  query myPatientAppointments {
    myPatientAppointments {
      id
      start_at
      oncologist {
        id
        name
        surname
        photo
        alboRegion {
            id
            name
        }
        albo_number
        policy_number
      }
      nutrizionist {
        id
        name
        surname
        photo
        alboRegion {
            id
            name
        }
        albo_number
        policy_number
      }
      has_patient_confirmed
      is_paid
      motivation
    }
  }
`;

export const MODIFY_APPOINTMENT = gql`
  mutation ModifyAppointment($id: Int!, $startAt: DateTime!, $motivation: String) {
    modifyAppointment(id: $id, start_at: $startAt, motivation: $motivation) {
      id
    }
  }
`;

export const DELETE_APPOINTMENT = gql`
  mutation deleteAppointment (
    $id: Int!,
    $motivation: String
  ) {
    deleteAppointment(id: $id, motivation: $motivation)
  }
`;

export const userAppointmentsQuery = {
  "patient": GET_PATIENT_APPOINTMENTS,
  "oncologist": GET_PROFESSIONIST_APPOINTMENTS,
  "nutrizionist": GET_PROFESSIONIST_APPOINTMENTS,
};

export const userAppointmentsData = {
  "patient": "myPatientAppointments",
  "oncologist": "myProfessionistAppointments",
  "nutrizionist": "myProfessionistAppointments",
};
